<div class="custom-upload-container" 
     [ngClass]="{
       'dragging': isDragging && !isInvalidFile && !isSuccess, 
       'invalid-file': isInvalidFile, 
       'dragging-invalid': isDragging && isInvalidFile,
       'success-file': isSuccess && !isInvalidFile
     }" 
     (dragover)="onDragOver($event)" 
     (dragleave)="onDragLeave($event)" 
     (drop)="onDrop($event)">
    <div class="upload-content">
        <!-- Cambia el ícono dependiendo del estado de carga del archivo -->
        <ng-container *ngIf="!fileLoaded; else fileLoadedTemplate">
            <mat-icon style="font-size: 40;" class="upload-icon empty" [svgIcon]="'mat_outline:folder'"></mat-icon>
            <h3 class="upload-title">{{title}}</h3>
            <p class="upload-description">Presiona seleccionar para elegir un archivo o arrastra y suelta aquí.</p>
            <button mat-raised-button color="primary" class="upload-button" (click)="fileInput.click()">Seleccionar</button>
        </ng-container>

        <!-- Template para cuando el archivo ya ha sido cargado -->
        <ng-template #fileLoadedTemplate>
            <mat-icon style="font-size: 40;" class="upload-icon success" [svgIcon]="'mat_outline:check_circle_outline'"></mat-icon>
            <h3 class="upload-title">Archivo cargado correctamente</h3>
            <p class="upload-description">Puedes cargar otro archivo si lo deseas.</p>
            <button mat-raised-button color="secondary" class="reupload-button" (click)="fileInput.click()">Seleccionar otro archivo</button>
        </ng-template>

        <input id="file" type="file" single (change)="onFileChange2($event)" [accept]="accept" style="display: none;" #fileInput>
    </div>
</div>
